import { BulkActionDataType } from '../../enums/bulk-action-data-type';
import { fulfillmentPlan } from './fulfillment-plan';
import { salesOrder } from './sales-order';
import { ordersShipmentsModeBatchDetailsFull } from './orders-shipments-mode-batch-details-full';
import { batchDetailsFull } from './batch-details-full';

const map = {
  [BulkActionDataType.SALES_ORDER]: salesOrder,
  [BulkActionDataType.FULFILLMENT_PLAN]: fulfillmentPlan,
  [BulkActionDataType.BATCH_DETAILS]: fulfillmentPlan,
  [BulkActionDataType.BATCH_DETAILS_FULL]: batchDetailsFull,
  [BulkActionDataType.ORDERS_SHIPMENT_MODE_BATCH_DETAILS_FULL]: ordersShipmentsModeBatchDetailsFull,
};

class BulkActionDataTypesClass {
  getBulkUpdateTypeData(dataTypeId) {
    const found = map[dataTypeId];
    if (found) {
      return found;
    }
  }
}

export const BulkActionDataTypes = new BulkActionDataTypesClass();
